













import { Vue, Prop, Component } from 'vue-property-decorator';
@Component({
  components: {
    Title1: () => import('@/components/siteBusiness/pc/home/Title1.vue'),
    proSwiper: () => import('@/components/siteBusiness/pc/home/proSwiper.vue')
  }
})
export default class Promotion2 extends Vue {
  private pmtList: object[] = [];

  proOption: object = {
    navigation: {
      nextEl: '.pro-swiper-button-next',
      prevEl: '.pro-swiper-button-prev'
    },
    slidesPerView: 3,
    slidesPerGroup: 3,
    spaceBetween: 30
  };

  getPromotionList () {
    this.$Api.promotion.getPromotionList('home').then(result => {
      this.pmtList = result.filter(item => item.Seq);
    });
  }

  mounted() {
    this.getPromotionList();
  }
}
